import React from 'react';
import styles from './AmbassadorHero.module.css';
import { Trans, useTranslation } from 'react-i18next';

const AmbassadorHero = () => {
    const { t } = useTranslation();

    return (
    <section className={styles.ambassadorhero}>
        <div className={styles['ambassadorhero-mask']}></div>
        <div className={styles['ambassadorhero-container']}>
            <div className={styles['ambassadorhero-content']}>
                <h1 className={styles['heading-ambassadorhero']}>
                <span className={styles['text-shadow']}>
                    <Trans i18nKey="ambassadorHero.colorTitle" components={{ br: <br /> }} />
                </span>
                <span className={styles['text-top']}>
                    <Trans i18nKey="ambassadorHero.shadowTitle" components={{ br: <br /> }} />
                </span>
                </h1>
            </div>
        </div>
    </section>
    );
};

export default AmbassadorHero;